import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'data-preview-dialog',
  templateUrl: 'data-preview-dialog.html'
})
export class DataPreviewDialog {

  constructor(
    public dialogRef: MatDialogRef<DataPreviewDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
